import { Divider, Typography } from "antd";
import React from "react";
import ColegioList from "./ColegioList";
import "./ColegioStyles.css";

const { Title } = Typography;

const ColegioManagement = () => {
    // const [refreshKey, setRefreshKey] = useState(0);
    // const [selectedColegio, setSelectedColegio] = useState(null);
    const isMobile = window.innerWidth < 768;

    // // Esta función se ejecutará cuando se agregue un nuevo colegio
    // const handleColegioAdded = () => {
    //     // Incrementar el key para forzar la actualización de la lista de colegios
    //     setRefreshKey((prevKey) => prevKey + 1);
    // };

    // Esta función se ejecutará cuando se edite un colegio
    // const handleColegioEdited = (colegio) => {
    //     setSelectedColegio(colegio);
    // };

    // // Esta función se ejecutará cuando se actualice un colegio
    // const handleColegioUpdated = () => {
    //     // Limpiar el colegio seleccionado e incrementar el key para actualizar la lista
    //     setSelectedColegio(null);
    //     setRefreshKey((prevKey) => prevKey + 1);
    // };

    return (
        <div className="colegio-management-container">
            <Title level={2}>{isMobile ? "Colegios" : "Gestión de Colegios"}</Title>
            <Divider />

            {/* <Row gutter={[24, 24]}> */}
            {/* <Col xs={24} lg={12}>
                    <Card>
                        <ColegioForm
                            onColegioAdded={handleColegioAdded}
                            onColegioUpdated={handleColegioUpdated}
                            colegioToEdit={selectedColegio}
                        />
                    </Card>
                </Col> */}

            {/* <Col xs={24} lg={12}> */}
            <ColegioList
            // refreshTrigger={refreshKey}
            // onEditColegio={handleColegioEdited}
            />
            {/* </Col> */}
            {/* </Row> */}
        </div>
    );
};

export default ColegioManagement; 